import store from '@/store';

export default class BroadcastWhatsAppListScheduleBulkUpdateEvent {
  constructor(body) {
    console.log(body);
    const agentId = store.state.attendance.Attendance.agentId;
    const broadcastWhatsAppId = body.id;
    const schedules = body.schedules;
    if (
      body.event == 'BroadcastWhatsAppListScheduleBulkUpdateEvent' &&
      agentId == body.agentId &&
      schedules.length > 0
    ) {
      const broadcastInformation = {
        broadcastWhatsAppId,
        schedules,
        type: 'bulk',
      };
      store.dispatch(
        'broadcast/updateBroadcastWhatsAppStatus',
        broadcastInformation,
      );
      console.log(
        '[AGENT/BROADCAST] - Broadcast ' +
          broadcastWhatsAppId +
          ' finalizado pelo sistema.',
      );
    }
  }
}
